import { render, staticRenderFns } from "./signNeighborhoodPact.vue?vue&type=template&id=23d1ed3d&scoped=true"
import script from "./signNeighborhoodPact.vue?vue&type=script&lang=js"
export * from "./signNeighborhoodPact.vue?vue&type=script&lang=js"
import style0 from "./signNeighborhoodPact.vue?vue&type=style&index=0&id=23d1ed3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d1ed3d",
  null
  
)

export default component.exports